module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-824e86656aca5447eb70790f78c657cb.png";